
function AuthenticationSubtitleText({error}) {
    // Used in AuthenticationScreen to display error
    // or subtitle text

    // BUILD
    if (error)
        return <span className={"text-red-400 font-normal text-[14px]"}>
                    {error}
               </span>
    return <h2 className={"text-neoSubtextColor font-normal text-[14px]"}>
                {'Renseignez votre identifiant avec votre mot de passe'}
           </h2>
}

// EXPORT
export default AuthenticationSubtitleText